module.exports = __webpack_public_path__ + "img/09.44c55178.jpg";